export default "__VITE_ASSET__C$BN0z1C__"